import { memo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function ChatMarkdown({ text }: { text: string }) {
  return (
    <div className="agent-chat-prose space-y-3 text-[0.95rem] leading-7">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        components={{
          a: ({ children, href }) => (
            <a
              href={href}
              target="_blank"
              rel="noreferrer noopener"
              className="font-medium underline underline-offset-2"
            >
              {children}
            </a>
          ),
          code: ({ children, className }) => {
            const fenced = Boolean(className);
            return (
              <code
                className={
                  fenced
                    ? className
                    : "rounded bg-muted px-1 py-0.5 font-mono text-[0.85em]"
                }
              >
                {children}
              </code>
            );
          },
          pre: ({ children }) => (
            <pre
              dir="ltr"
              className="max-w-full overflow-x-auto rounded-xl bg-muted p-3 text-start text-xs leading-5"
            >
              {children}
            </pre>
          ),
          table: ({ children }) => (
            <div className="max-w-full overflow-x-auto">
              <table className="w-full min-w-56 border-collapse text-start text-sm">
                {children}
              </table>
            </div>
          ),
          th: ({ children }) => (
            <th className="border border-border bg-muted/70 px-3 py-2 font-semibold">
              {children}
            </th>
          ),
          td: ({ children }) => (
            <td className="border border-border px-3 py-2">{children}</td>
          ),
          ul: ({ children }) => <ul className="list-disc space-y-1 ps-5">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal space-y-1 ps-5">{children}</ol>,
          h1: ({ children }) => (
            <h1 className="text-xl font-semibold tracking-tight">{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className="text-lg font-semibold tracking-tight">{children}</h2>
          ),
          h3: ({ children }) => <h3 className="text-base font-semibold">{children}</h3>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}

export default memo(ChatMarkdown);
